import { render, staticRenderFns } from "./BatchOperateBindAdmin.vue?vue&type=template&id=a0dc31cc&scoped=true"
import script from "./BatchOperateBindAdmin.vue?vue&type=script&lang=ts"
export * from "./BatchOperateBindAdmin.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateBindAdmin.vue?vue&type=style&index=0&id=a0dc31cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dc31cc",
  null
  
)

export default component.exports